import { Snackbar, ThemeProvider, Typography, createTheme } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import { AlertTitle } from "@material-ui/lab";
import { ReactNode, useState } from "react";
import Slide from '@material-ui/core/Slide';
import { TransitionProps } from '@material-ui/core/transitions';

interface SnackbarAlertProps {
    message: ReactNode;
    severity?: 'success' | 'info' | 'warning' | 'error';
    autoHideDuration?: number | null;
}

export default function SnackbarAlert({ message, severity, autoHideDuration }: SnackbarAlertProps) {

    const [open, setOpen] = useState(true);

    const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpen(false);
    };

    const snackbarTheme = createTheme({
        palette: {
            primary: {
                main: '#005BAE',
            },
        },
        typography: {
            fontFamily: 'Roboto, Sarabun',
            fontSize: 14,
            fontWeightBold: 500,
        },
    });

    return (
        <div className="snackbar-alert">
            <ThemeProvider theme={snackbarTheme}>
                <Snackbar open={open} autoHideDuration={autoHideDuration || 5000} onClose={handleClose} TransitionComponent={Slide}>
                    <Alert severity={severity || "info"} onClose={handleClose}>
                        <AlertTitle>{severity?.charAt(0).toUpperCase()}{severity?.slice(1)}</AlertTitle>
                        {message}
                    </Alert>
                </Snackbar>
            </ThemeProvider>
        </div>
    )
}